import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import type {CommentListResultVo} from '../../common/shared/api/nicolas/vo/comment/CommentListResultVo.interface';
import {trimUndefinedFromObject} from '../../common/util/trimUndefinedFromObject';

/**
 * 베스트 댓글 목록 조회
 *
 * Origin: pageNicolasApi.getBestCommentList
 * API: GET /api/v1/store/community/best/list
 */
export async function getStoreCommunityBestList(
  params: {
    seriesId: number;
    productId?: number;
    page: number;
    size?: number;
  },
  options?: FetcherOptions
): Promise<ApiResultV2Vo<CommentListResultVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/community/best/list',
    {
      method: 'GET',
      params: trimUndefinedFromObject({
        series_id: params.seriesId,
        single_id: params.productId,
        page: params.page,
        size: params.size,
      }),
    },
    options
  );
  return response.data;
}
